import { KeyboardArrowRight as KeyboardArrowRightIcon } from '@mui/icons-material';

const KeyboardArrowRight = (): JSX.Element => <KeyboardArrowRightIcon fontSize="inherit" />;

export default KeyboardArrowRight;
